import user from './images/Photo.svg';

export const dataUser = [
    {
        id: 1,
        userName: 'خالد السيد',
        points: '55000',
        imageUser: user
    }
]